import React, { useMemo } from 'react';
import { Col, SelectInput } from '../../../../landing.common';
import { Controller, UseFormReturn } from 'react-hook-form';
import { FORM_FIELDS } from '../../../../../constants';
import { Row } from '../../common';

interface Props {
    form: UseFormReturn;
}

export const WhenMoneyNeeded: React.FC<Props> = (props) => {
    const { form } = props;
    const {
        control,
        formState: { errors, dirtyFields: _ },
    } = form;

    const whenMoneyNeededOptions = useMemo(
        () => [
            { value: 'Срочно', label: 'Срочно' },
            { value: 'Присматриваюсь', label: 'Присматриваюсь' },
            { value: 'В ближайшее время', label: 'В ближайшее время' },
        ],
        [],
    );

    return (
        <Row>
            <Col md-4>
                <Controller
                    control={control}
                    name={FORM_FIELDS.WHEN_MONEY_NEEDED}
                    render={({ field }) => (
                        <SelectInput
                            {...field}
                            label="Когда нужны деньги?"
                            options={whenMoneyNeededOptions}
                            errorMessage={errors[FORM_FIELDS.WHEN_MONEY_NEEDED]?.message}
                            withCrossIcon={false}
                        />
                    )}
                />
            </Col>
        </Row>
    );
};
